export default __webpack_public_path__ + "static/media/hamburgerIcon.e02af209.webp";